import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
const firebaseConfig = {
  apiKey: "AIzaSyBr0HC7deEhG4BWYf66Cl6nUDaZbPE7l8I",
  authDomain: "dreamstreamai.firebaseapp.com",
  projectId: "dreamstreamai",
  storageBucket: "dreamstreamai.firebasestorage.app",
  messagingSenderId: "273301604826",
  appId: "1:273301604826:web:eceeea072d9ee7d52018e3",
  measurementId: "1:273301604826:web:eceeea072d9ee7d52018e3",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export default firebase;
